import React, { PropTypes, Component } from "react";

import ChartPie, {
  categoryPieFormatter
} from "../charts/chart-bar/ChartPieAdv";

import { NitroDivider } from "nitro-components";

import SummaryHeading from "./SummaryHeading.js";

class GenericPie extends Component {
  render() {
    // console.log('GenericPie', this.props);

    const { title, HeaderPostFix, dataType } = this.props;

    return (
      <span>

        {/* <NitroHeading label={title} labelHighlight={HeaderPostFix} size="1" align="center" noMargin/> */}

        <div style={{ height: "50px" }} />

        <SummaryHeading title={title} result={HeaderPostFix} />

        <NitroDivider noTopPad />

        <ChartPie
          data={categoryPieFormatter(this.props.data)}
          dataType={dataType}
        />

      </span>
    );
  }
}

GenericPie.propTypes = {
  dataType: PropTypes.string,
  actions: PropTypes.object,
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  handleTypeClick: PropTypes.func,
  handleBackClick: PropTypes.func,
  HeaderPostFix: PropTypes.string
};

export default GenericPie;



// WEBPACK FOOTER //
// ./src/components/factoryComponents/GenericPie.js